export default __webpack_public_path__ + "static/media/users.b550507a.svg";